<template>
  <v-card>
    <v-card-title>
      <v-btn
        v-can="'create_checkpoint'"
        color="primary"
        dark
        @click="dialogModal(true, 'create')"
      >
        <v-icon dark>
          mdi-plus
        </v-icon>
        {{ $('create') }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="checkpoints"
      :options.sync="options"
      :server-items-length="checkpointsTotal"
      :loading="loading"
      :disable-filtering="true"

      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions:[10, 20, 50, 100, -1],
        itemsPerPageText: $t('dataTable.itemsPerPageText'),
        pageText: $t('dataTable.pageText'),
        itemsPerPageAllText: $t('dataTable.itemsPerPageAllText'),
      }"
      :hide-default-header="!$vuetify.breakpoint.mobile"
      @update:page="fetch"
      @update:items-per-page="fetch"
    >
      <template v-if="!$vuetify.breakpoint.mobile" v-slot:header="{ props }">
        <datatable-header :props="props" :options.sync="options" :translation-key="translationKey"
                          @update:filters="fetch"></datatable-header>
      </template>

      <template v-slot:item.name="{ item }">
        {{ item.name | short_string(200) }}
      </template>
      <template v-slot:item.address="{ item }">
        {{ item.address | short_string(200) }}
      </template>
      <template v-slot:item.active="{ item }">
        <v-btn
          depressed
          data-toggle="tooltip"
          data-placement="top"
          title="تغيير الحالة"
          :color="item.active ? 'success' : 'error'"
          rounded
          small
          outlined
          @click="toggleActive(item)"
        >
          {{ item.active ? 'فعالة' : 'غير فعالة' }}
          <v-icon
            dark
            right
          >
            {{ item.active ? 'mdi-power' : 'mdi-power-off' }}
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:item.type="{ item }">
        <v-btn
          :color="item.type ? 'success' : 'error'"
          x-small
        >
          {{ item.type ? 'خارجية' : ' داخلية' }}
        </v-btn>
      </template>

      <template v-slot:item.funerals="{ item }">
        <v-btn
          depressed
          :color="item.funerals ? 'success' : 'error'"
          rounded
          small
          outlined
          @click="toggleFunerals(item)"
        >
          {{ item.funerals ? 'مسموح' : 'غير مسموح' }}
          <v-icon
            dark
            right
          >
            {{ item.funerals ? 'mdi-check' : 'mdi-block-helper' }}
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:item.created_at="{item}">
        {{ item.created_at | format_date }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                color="dark"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <menu-item v-can="'update_checkpoint'" :label="$('update')" color="info" icon="mdi-pencil"
                         @click="dialogModal(true, 'update', item.id)"></menu-item>
              <menu-item v-can="'delete_checkpoint'" :label="$('delete')" color="error" icon="mdi-delete"
                         @click="dialogModal(true, 'delete', item.id)"></menu-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>

    <check-point-dialog
      :dialog-modal="dialogModal"
      :data="dialogData"
      :translation-key="translationKey"
      @update:table="fetch"
    ></check-point-dialog>
  </v-card>
</template>

<script>
import axios from '@axios'
import CheckPointDialog from '@/views/pages/checkpoints/dialog.vue'
import DatatableHeader from '@/components/dataTables/DatatableHeader.vue'

import {ObjectToQuery} from '@/plugins/helper';
import {getFilters, getOptions} from '@/components/dataTables/helper'
import toast from '@/store/toast'
import MenuItem from '@/components/menu/menuItem.vue';

export default {
  name: 'Checkpoints',
  components: {DatatableHeader, CheckPointDialog, MenuItem},
  data: () => ({
    translationKey: 'pages.checkpoints',
    filters: false,
    page: 1,
    checkpoints: [],
    checkpointsTotal: 0,
    loading: true,
    options: {},
    tempOptions: '',
    search: '',
    dialogData: {
      dialog: false,
      type: 'create',
      id: null,
    },
    headers: [
      {
        text: 'name',
        align: 'center',
        sortable: false,
        value: 'name',
        sort: true,
        filter: {
          menu: false,
          type: 'text',
          methods: ['contains', 'startWith', 'endWith', 'equal', 'notEqual'],
        },
      },
      {
        text: 'address',
        value: 'address',
        align: 'center',
        sort: true,
        filter: {
          menu: false,
          type: 'text',
          methods: ['contains', 'startWith', 'endWith', 'equal', 'notEqual'],
        },
      },
      {
        text: 'active',
        value: 'active',
        align: 'center',
        sort: true,
        filter: {
          menu: false,
          type: 'switch',
          label: 'فعال',
        },
      },
      {
        text: 'type',
        value: 'type',
        align: 'center',
        sort: true,
        filter: {
          menu: false,
          type: 'switch',
          label: 'النوع',
        },
      },
      {
        text: 'funerals',
        value: 'funerals',
        align: 'center',
        sort: true,
        filter: {
          menu: false,
          type: 'switch',
          label: 'يسمح',
        },
      },
      {
        text: 'created_at',
        value: 'created_at',
        align: 'center',
        sort: true,
        filter: {
          menu: false,
          type: 'date',
          methods: ['between', 'greater', 'less', 'equal', 'notEqual'],
        },
      },
      {
        text: 'actions',
        value: 'actions',
        align: 'center',
      },
    ],
  }),
  setup() {
    return {}
  },
  mounted() {
    this.options = getOptions(this.$route, this.options);
    this.fetch();
  },

  methods: {
    async fetch() {
      if (JSON.stringify(this.options) !== this.tempOptions) {
        this.tempOptions = JSON.stringify(this.options);
        await this.$router.replace({query: this.options})
      }
      window.scrollTo(0, 0);
      localStorage.setItem(`itemsPerPage_${this.$route.name}`, this.options.itemsPerPage);
      this.loading = true;
      const filters = getFilters(this.headers);
      const query = ObjectToQuery({
        ...this.options,
        filters,
      })
      const response = await axios.get(`/checkpoints/dt?${query}`);
      this.checkpoints = response.data.data.data
      this.checkpointsTotal = response.data.data.total
      this.loading = false
    },
    async toggleActive(item) {
      if (this.$can("update_checkpoint")) {
        item.active = !item.active;
        if (item.active === true) {
          await toast.dispatch('success', this.$t('form.success.activate'))
        } else {
          await toast.dispatch('success', this.$t('form.success.deactivate'))
        }
        const response = await axios.post(`/checkpoints/edit/${item.id}`, item);

        this.fetch();
      }
    },

    async toggleFunerals(item) {
      if (!this.$can("update_identifiers"))  return ;
      item.funerals = !item.funerals;
      if (item.funerals === true) {
        await toast.dispatch('success', this.$t('form.success.change'))
      } else {
        await toast.dispatch('success', this.$t('form.success.change'))
      }
      const response = await axios.post(`/checkpoints/edit/${item.id}`, item);
      this.fetch();
    },

    dialogModal(dialog, type = this.dialogData.type, id = null) {
      this.dialogData.dialog = dialog;
      this.dialogData.type = type;
      this.dialogData.id = id;
    },
    $(key) {
      return this.$t(`${this.translationKey}.${key}`);
    },
  },

}
</script>
